<template>
  <opened
    ref="LeaseSetup"
    :leaseInfoParams="renderData.model.leaseInfoParams"
    :maitenaceParams="renderData.model.maitenaceParams"
    :tableDataFrom="renderData.model.tableDataFrom"
    :renderData="renderData"
    :topPreviewModel="renderData.model.topPreviewModel"
    @cancel="cancel"
    @previousStep="previousStep"
    @confirm="confirm"
  />
</template>
<script>
import opened from './new.vue'

export default {
  name: 'personalAddOrderIndex',
  props: {
    renderData: {
      type: Object,
      default: () => ({}),
    },
  },
  components: { opened },
  methods: {
    // eslint-disable-next-line vue/no-unused-properties
    planChange(id) {
      this.$refs.LeaseSetup.planChange(id)
    },
    cancel() {
      this.$emit('cancel')
    },
    confirm(accruedPlanParamList) {
      this.$emit('confirm', accruedPlanParamList)
    },
    previousStep() {
      this.$emit('previousStep')
    },
  },
}
</script>
